import { createAction, makeActionTrackable } from '@lingoda/core';

export default makeActionTrackable(
    createAction(
        'auth/UPDATE_FORGOTTEN_PASSWORD',
        (token: string, data: { plainPassword: string }) => ({ token, data }),
    ),
);
